import { Component, OnInit, ViewChild, ɵConsole } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from '../../../../bizlogic/servicesbll';
import { BaseCase } from '../../../basecase';
import {BaseModal} from '../../../../model/base';
import { PlatformLocation} from '@angular/common';
declare var app;
@Component({
  selector: 'app-sfa-list-score-add',
  templateUrl: './sfa-list-score-add.component.html',
  styleUrls: ['./sfa-list-score-add.component.scss']
})
export class SfaListScoreAddComponent extends GridBaseCase {

  dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  constructor( 
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base:BaseModal,
    private platformlocation:PlatformLocation) { super(); }

    loadMoreData(event) {
      let that = this;
      if (that.RecordCount == that.dataArrayList.length) {
        that.infiniteScroll.disabled = true;
      } else {
        that.PageNumber++;
        this.LoadData(that.PageNumber);
      }
    }

    LoadData(PageNumber) {
      const that = this;
      that.PageNumber = PageNumber;
      if (PageNumber == 1) {
        that.loading = false;
        that.apiObj['status'] = false;
        that.apiObj['msg'] = '';
      }
  
      const pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      const id = that.activaRouter.snapshot.paramMap.get('id');
      let body: WebParameterContext = new WebParameterContext();
      if (that.element.selectItemList.gridViewConfigName) {
        body.ConfigName = that.element.selectItemList.gridViewConfigName;
      } else if (that.ConfigName) {
        body.ConfigName = that.ConfigName;
      }
      body.Account = that.com.GetAccount;
      body.OpType = "query";
      body.ConfigType = "view";
      body.RowsPerPage = app.RowsPerPage;
      body.PageNumber = PageNumber;
      body.Client.Name = pageName;
      body.Client.PageName = pageName;
      let _obj={};
          _obj["userId"]=id;
      // let nowyear: any = that.com.getNow.split('-')[0];
      // let nowmonth: any = that.com.getNow.split('-')[1];
      // let startDate = nowyear + "-" + nowmonth + "-" + "01" + " 00:00:00";
      // let day = new Date(nowyear, nowmonth, 0);
      // let endDate = nowyear + "-" + nowmonth + "-" + day.getDate() + " 23:59:59";
      //    _obj["a_CreateTime"]=that.com.BetweenDate(startDate, endDate);;
      // body = HandleWebParameterContextBeforeDBRequest(body);
      // if (!body.ResponseMessage.Success) {
      //   that.msg.Alert(body.ResponseMessage.ErrorMessage);
      //   return;
      // }
      body.RequestBody = JSON.stringify(_obj);
      that.http.post(app.DEFAULTURL, body).then(data => {
        // data = HandleServerContextAfterDBRequest(body, data);
        /****判断是否第一页begin****/
        if(PageNumber == 1){
          that.dataArrayList = [];
          that.apiObj['status'] = data.ResponseMessage.Success;
          that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
          that.loading = true;
        }else{
          that.infiniteScroll.complete();
        }
        /****判断是否第一页end****/
        if (data.ResponseMessage.Success) {
          data.Status.Datas.forEach(function (item) {
            let objfield = {};
            that.element.selectItemList.selectItem.forEach((element, index) => {
              if (element.bindingField) {
                objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
              }
            });
            that.dataArrayList.push(objfield);
          });
        console.log(that.dataArrayList);
        //判断是否有值
        that.dataArrayList.forEach(item=>{
          if(item.fid.value){
            item.isCheck=item.score.value;
          }
        })
          /****上拉加载数据begin****/
          that.RecordCount = data.Status.RecordCount;
          if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
            that.infiniteScroll.disabled = true;
          }else{
            that.infiniteScroll.disabled = false;
          }
          /****上拉加载数据end****/
        } else {
          console.log(data.ResponseMessage.ErrorMessage);
        }
      }).catch(error => {
        that.loading = true;
        that.apiObj['status'] = false;
        that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
  
        console.log(error);
      })
    }
    EventLink(ev: any, parms: any) {
      let evs = ev.url || '';
      if (evs.trim() && parms) {
        if (evs.indexOf("http") > 0) {
        } else {
          this.com.Go(evs + "/" + parms.id);
        }
      }
  
    }

    EventSelect(i,item){
      item["isCheck"] = i;
      console.log(item);
      this.submitArr();
    }

    submitArr(){
      let arr = [];
      this.dataArrayList.forEach(item=>{
        let obj = {};
        obj["id"] = item["id"]["value"];
        if(item["isCheck"] == 1){
          obj["score"] = 1;
          arr.push(obj);
        }else if(item["isCheck"] == 0){
          obj["score"] = 0;
          arr.push(obj);
        }
      })
      console.log(arr);
    }

    submit(){
      const that = this;
      const id = that.activaRouter.snapshot.paramMap.get('id');
      let temparrayList:Array<any> = new Array<any>();
       const arrayList:any= that.dataArrayList.find(item=>item.isCheck);
       console.log(arrayList);
       if(arrayList){

      let configName=that.activaRouter.snapshot.paramMap.get('ConfigName');
      let getID=that.activaRouter.snapshot.paramMap.get("id");
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
      body.ConfigName = "TBScoringXML";
      body.OpType = "add";
      body.ConfigType = "form";
      body.Client.PageName = configName;
      body.Client.ApiType = "Content";
      body.Client.Name = that.template.content.name;
      body.Client.Type = "add";
      body.Client.ClientType = 2;
      that.dataArrayList.forEach(item=>{
        if(typeof(item.isCheck)!="undefined"){
          let obj={};
          if(item.fid.value){
            // body.OpType = "EDITE";
               obj["a_ID"]=item.fid.value;
             }
              obj["a_FK_TBStore_ID"]=that.com.GetStorageKey("tbstore").ID;
              obj["a_FK_TBPromoterScoring_ID"]=item.id.value;
              obj["a_Score"]=item.isCheck;
              obj["a_FK_SystemUser_ID"]=id;
              temparrayList.push(obj);
        }
      });
      // body.CurrentDepartment = that.base.Department;
      if (that.platform.is("android")) {
        body.Client.ClientType = 0;
      } else if (that.platform.is("ios")) {
        body.Client.ClientType = 1;
      }
      if(temparrayList.length<=0){
        that.msg.Alert("请选择数据");
      }
      console.log(temparrayList);
      body.RequestBody = JSON.stringify(temparrayList);
      that.msg.Loading("数据提交中...").then(load => {
        that.http.post(app.DEFAULTURL, body).then(
          data => {
            if (data.ResponseMessage.Success) {
              load.dismiss();
                //按钮添加权限
                let out = that.com.GetStorageKey("btn");
                if(out){
                  that.com.setBadge(out.pagename,out.temp,out.name);
                  localStorage.removeItem("btn");
                }
              localStorage.removeItem(this.template.name);
              // that.router.navigate(["/tabs/contact/PingFenList/"+that.com.getNowDatetime]);
              that.com.Go("/tabs/contact/PingFenList/"+that.com.getNowDatetime);
            } else {
              load.dismiss();
              // that.msg.Show(data.ResponseMessage.ErrorMessage);
              that.msg.Alert("目前网络繁忙，请稍后再试");
            }
          }
        ).catch(error => {
          load.dismiss();
          that.msg.Alert("目前网络繁忙，请稍后再试");
        });
        load.present();
      });
       }else{
         that.msg.Alert("请选择");
       }
    }
 

}
